<ion-content class="coach-profiles-wrap content">
    <ion-header class="transparent absolute">
        <app-header [backRoute]="['/home']"></app-header>
    </ion-header>
    <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform == 'mobile'}" [@enter]>
    </div>
        <div class="shadow-container">
            <div class="coach-head">
                <div class="coach-head-text my-color-blue">
                    <div>{{'__COACH_PROF_TEXT__' | translate}}</div>
                    <div class="coach-groups" *ngIf="coachGroups && coachGroups.length" >
<!--                    <div class="groups-title">Choose a Topic</div>-->
                    <div class="groups-title">
                        {{'__COACH_PROFILES_GROUP_SELECT_TEXT__' | translate}}
                    </div>
                        <app-coach-groups-dropdown [items]="coachGroups"></app-coach-groups-dropdown>
                    </div>
                </div>
                <div class="coach-grey-text">
                    {{'__COACH_SELECTION_TEXT__' | translate}}
                </div>
            </div>
            <div class="inner-container" *ngIf="coachesList">
                <ng-container *ngFor="let coach of coachesList">
                    <div class="profile-box-wrap" *ngIf="coachGroupSelected(coach)">
                        <div class="coach-calendar">
                            <a [routerLink]="['/coach/profile/'+coach.id+'/calendar']">
                                <img src="assets/img/coach-calendar-main.svg" />
                            </a>
                        </div>
                        <div class="white-group" [routerLink]="['/coach/profile/'+coach.id]">
                            <div class="empty-container"></div>
                            <div class="coach-profile-photo">
                                <img *ngIf="coach.file === null" src="assets/img/user-blue.svg" />
                                <img *ngIf="coach.file !== null" [src]="coach.file.url" />
                            </div>
                            <div class="coach-name">{{coach.full_name}}</div>
                            <div class="coach-speciality">
                                {{coach.job_title}}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="inner-container" *ngIf="!coachesList">
                <ng-container *ngFor="let coach of [1,2,3,4]">
                    <div class="white-group">
                        <div class="coach-calendar"><ion-skeleton-text animated></ion-skeleton-text></div>
                        <div class="coach-profile-photo"><ion-skeleton-text animated></ion-skeleton-text></div>
                        <div class="coach-name">
                            <ion-skeleton-text animated style="width: 10rem; height: 1.3rem"></ion-skeleton-text>
                        </div>
                        <div class="coach-speciality">
                            <ion-skeleton-text animated style="height: 0.7rem"></ion-skeleton-text>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
        <app-footer-logo></app-footer-logo>
</ion-content>
